import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { PaymentDictionaryActions } from '../../reducers/paymentDictionary/actionNames'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import {
  loadDefaultTaxServices,
  loadTaxServices,
  updateTaxServices,
} from '../../models/PaymentDictionary'
import { getUserLanguage } from '../../reducers/userAccount/selectors/userAccount'
import { IServices } from '../../models/PaymentDictionary/loadTaxServices'
import { IDefaultServices } from '../../models/PaymentDictionary/loadDefaultTaxServices'
import updateDefaultTaxServices from '../../models/PaymentDictionary/updateDefaultTaxServices'
import { getDefaultTaxServices } from '../../reducers/paymentDictionary/selectors/getPaymentDictionary'

function* loadServices() {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchServices)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, loadTaxServices),
      ),
    ])

    const lang = yield Effects.select(getUserLanguage)

    const services: IServices[] = yield Effects.call(service, lang)

    yield Effects.put({
      services: services.filter(s => !s.deleted).reverse(),
      type: PaymentDictionaryActions.AcceptedServices,
    })
  } catch (e) {
    console.error(e)
  }
}

function* saveServices(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdateServices)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, updateTaxServices),
      ),
    ])

    const lang = yield Effects.select(getUserLanguage)

    yield Effects.call(
      service as any,
      lang,
      Object.values(action.services).reverse(),
    )

    yield Effects.put({
      type: PaymentDictionaryActions.RequestServices,
    })
    yield put(fireToastSuccess(i18n.t('user_settings_updated')))
  } catch (e) {
    console.error(e)
  }
}

function* loadDefaultServices() {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchDefaultServices)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          loadDefaultTaxServices,
        ),
      ),
    ])

    const lang = yield Effects.select(getUserLanguage)

    const services: IDefaultServices = yield Effects.call(service, lang)

    yield Effects.put({
      services,
      type: PaymentDictionaryActions.AcceptedDefaultServices,
    })
  } catch (e) {
    console.error(e)
  }
}

function* saveDefaultServices(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdateDefaultServices)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          updateDefaultTaxServices,
        ),
      ),
    ])

    const lang = yield Effects.select(getUserLanguage)
    const defaultService = yield Effects.select(getDefaultTaxServices)
    const services: any = yield Effects.call(
      service,
      lang,
      action.services,
      defaultService,
    )

    yield Effects.put({
      services,
      type: PaymentDictionaryActions.AcceptedDefaultServices,
    })
    yield put(fireToastSuccess(i18n.t('user_settings_updated')))
  } catch (e) {
    console.error(e)
  }
}

function* saveForm(action) {
  yield Effects.put({
    services: {
      deleted: '0',
      first_tax: action.values.first_tax,
      name: action.values.name,
      second_tax: action.values.second_tax,
    },
    type: PaymentDictionaryActions.SaveDefaultServices,
  })

  if (!action.only) {
    yield Effects.put({
      services: {
        ...action.values.services,
      },
      type: PaymentDictionaryActions.SaveServices,
    })
  }
}

export default function*() {
  yield Effects.takeEvery(
    PaymentDictionaryActions.RequestServices,
    loadServices,
  )
  yield Effects.takeEvery(PaymentDictionaryActions.SaveServices, saveServices)
  yield Effects.takeEvery(
    PaymentDictionaryActions.RequestDefaultServices,
    loadDefaultServices,
  )
  yield Effects.takeEvery(PaymentDictionaryActions.SaveServicesForm, saveForm)
  yield Effects.takeEvery(
    PaymentDictionaryActions.SaveDefaultServices,
    saveDefaultServices,
  )
}
